// First-launch consent (T-007, D48): Terms + Privacy acceptance only, before the map. Bump
// TERMS_VERSION when the Terms or the Privacy Policy change: everyone accepts again.
import { z } from 'zod';

export const TERMS_VERSION = 1;
/**
 * D5/D44: the youngest age the age rules know (teens-only events are 14–17). Nobody is refused
 * by age while the age gate is off (D48).
 */
export const APP_MIN_AGE = 14;

/** `POST /v1/me/consent`: only the Terms version (D48: no birth date). */
export const consentRequestSchema = z.strictObject({
	termsVersion: z.literal(TERMS_VERSION),
});

export type ConsentRequest = z.infer<typeof consentRequestSchema>;
